
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import Upload from '@/components/UploadImage'
import CPosition from '@/components/Position'
export default {
name: 'Order',
components: {
Cell,
Group,
Timeline,
TimelineItem,
XButton,
Flexbox,
FlexboxItem,
Upload,
XTextarea,
CPosition
},
data () {
return {
ID: '',
MEMO: '',
isComplete: false,
uploadParams: {},
color: 'red',
order: {},
orderFiles: [],
demageFiles: [],
th_orderFiles: null,
th_demageFiles: null,
hasOrderImg: false, // 是否已经提交送货交接单
hasDemageImg: false, // 是否已经提交破损交接单
isSubmit: false
}
},
computed: {
position () {
return this.$store.getters.getPosition
}
},
created () {
this.ID = this.$route.query.ID || ''
if (process.env.NODE_ENV != 'development' && this.$store.state.app.roleid != 0) {
this.$router.replace({
path: './sh/order?ID=' + this.ID
})
return
}
this.uploadParams = {
SUBDIR: this.$config.SUBDIR.ps
}
this.loadData()
this.$store.dispatch('baiduPosition')
},
methods: {
loadData () {
let _this = this
_this.$vux.loading.show()
let url = 'Trans.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.isComplete = [10, 11, 12].indexOf(_this.order.STATUS) !== -1
_this.color = _this.isComplete ? '#04BE02' : 'red'
if (_this.isComplete) _this.MEMO = _this.order.SIGN_MEMO
_this.$vux.loading.hide()
_this.getOrderFiles()
_this.isSubmit = false
}
).catch(
response => {
}
)
},
getThOrder () {

},
getOrderFiles () {
let _this = this
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.ps_order, res => {
if (res.length > 0) _this.hasOrderImg = true
_this.orderFiles = res
})
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.ps_demage, res => {
if (res.length > 0) _this.hasDemageImg = true
_this.demageFiles = res
})
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_order, res => {
_this.th_orderFiles = res
})
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_demage, res => {
_this.th_demageFiles = res
})
},
submitOrderFiles (file) {
if (this.orderFiles.length > 0) this.hasOrderImg = true
else this.hasOrderImg = false
},
submitDemageFiles (file) {
let _this = this
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.ps_order, file, function (res) {
if (res) _this.hasDemageImg = true
})
},
toTransDone () {
let _this = this
if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr,
ALARM_INFO: JSON.stringify({
MSG_CODE: 'TRANS_DONE',
BASE_ID: 22
})
}
_this.$post('Trans.ashx?action=Update_Over', param).then(res => {
_this.$toast.success('完成送货成功')
setTimeout(() => {
_this.loadData()
}, 1000)
}).catch(res => {
_this.isSubmit = false
})
},
toSign () {
let _this = this





let fileArr = []
this.orderFiles.forEach(item => {
fileArr.push({
F_SRC: _this.$config.F_SRC.ps_order,
DOC_NO: _this.order.WORKNO,
FILE_DNM: item.name,
FILE_UNM: item.URL
})
})

if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
SIGN_MEMO: _this.MEMO,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr,
WEBFILE_INFO: JSON.stringify(fileArr)
}
_this.$post('Trans.ashx?action=Update_Sign', param).then(res => {
_this.$toast.success('签收成功')
setTimeout(() => {
_this.loadData()
}, 1000)
}).catch(res => {
_this.isSubmit = false
})
},
toConfirm () {
let _this = this
if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
WORKNO: this.order.WORKNO,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr
}
_this.$post('Trans.ashx?action=Update_Confirm', param).then(res => {
_this.$toast.success('离场成功')
setTimeout(() => {
_this.loadData()
}, 1000)
}).catch(res => {
_this.isSubmit = false
})
},
toHK () {
let _this = this
if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
WORKNO: this.order.WORKNO,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr
}
_this.$post('Trans.ashx?action=Update_HK', param).then(res => {
_this.$toast.success('已还空箱操作成功')
setTimeout(() => {
_this.loadData()
_this.$route.back()
}, 1000)
}).catch(res => {
_this.isSubmit = false
})
},
toAbnormal () {
this.$router.push({
path: './abnormal?TYPE=0&ID=' + this.ID
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/sctsnew/Psd.vue